
import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { MailDomain } from 'src/app/models/directory/enums/MailDomain.enum';

export class EmailValidators {
  static  mustNotBeChevronEmailDomain(): ValidatorFn {
    const mustNotBeChevronEmailDomain: string[] =
      Object.values(MailDomain).map(domain => domain.toLowerCase());

    return (control: AbstractControl): ValidationErrors | null => {
      const value =
        control.value?.trim().toLowerCase();
      if (!value) return null;

      const emailDomain = value.split('@')[1];
      if (!emailDomain) return null;
      const isChevronEmailDomain = mustNotBeChevronEmailDomain.includes(emailDomain);

      return isChevronEmailDomain ? { mustNotBeChevronEmailDomain: true } :
        null;
    };
  }
}